import { yup, yupResolver } from '@sahinyazilim/sahinyazilim-components';

export const ProductFormYup = yupResolver<any>(
  yup
    .object({
      name: yup.string().min(2).required(),
      price: yup.number().min(0).required(),
      description: yup.string().min(0).required(),
    })
    .required(),
);
